/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest =
  {
    accountId: string;
    ledgerCanisterId: string;
    offset?: number | undefined;
    limit?: number | undefined;
    start?: number | undefined;
    end?: number | undefined;
  };

/** @internal */
export const ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest$inboundSchema:
  z.ZodType<
    ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    account_id: z.string(),
    ledger_canister_id: z.string(),
    offset: z.number().int().optional(),
    limit: z.number().int().optional(),
    start: z.number().optional(),
    end: z.number().optional(),
  }).transform((v) => {
    return remap$(v, {
      "account_id": "accountId",
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest$Outbound =
  {
    account_id: string;
    ledger_canister_id: string;
    offset?: number | undefined;
    limit?: number | undefined;
    start?: number | undefined;
    end?: number | undefined;
  };

/** @internal */
export const ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest$outboundSchema:
  z.ZodType<
    ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest$Outbound,
    z.ZodTypeDef,
    ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest
  > = z.object({
    accountId: z.string(),
    ledgerCanisterId: z.string(),
    offset: z.number().int().optional(),
    limit: z.number().int().optional(),
    start: z.number().optional(),
    end: z.number().optional(),
  }).transform((v) => {
    return remap$(v, {
      accountId: "account_id",
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest$ {
  /** @deprecated use `ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest$inboundSchema;
  /** @deprecated use `ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest$outboundSchema;
  /** @deprecated use `ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest$Outbound` instead. */
  export type Outbound =
    ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest$Outbound;
}

export function listAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequestToJSON(
  listAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest:
    ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest,
): string {
  return JSON.stringify(
    ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest$outboundSchema
      .parse(
        listAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest,
      ),
  );
}

export function listAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest' from JSON`,
  );
}
